<template>
    <div class="form-check-inline">
        <label :for="id" class="form-check-label mr-2">Show Triggered Markets</label>
        <input @change="changeShowTriggered" :id="id" type="checkbox" v-model="showTriggered" :value="true" class="form-check-input">
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue';
import { useIsJim } from '../../mixins/IsJim';

const eventBus = inject('eventBus');
const { isJim } = useIsJim();

const showTriggered = ref(false);
const id = `show-trigger-${(Math.floor(Math.random() * 1000)).toString(36)}`;

const changeShowTriggered = () => {
    eventBus.emit('showTriggered', showTriggered.value);
};

onMounted(() => {
    eventBus.on('data-loaded', () => {
        if (isJim()) {
            showTriggered.value = false;
        }
        if (showTriggered.value) {
            changeShowTriggered();
        }
    });
});
</script>
